/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { Directive, TemplateRef } from '@angular/core';
import { CdkStepLabel } from '@angular/cdk/stepper';
/**
 * Workaround for https://github.com/angular/angular/issues/17849
 */
export const _MatStepLabel = CdkStepLabel;
export class MatStepLabel extends _MatStepLabel {
    /**
     * @param {?} template
     */
    constructor(template) {
        super(template);
    }
}
MatStepLabel.decorators = [
    { type: Directive, args: [{
                selector: '[matStepLabel]',
            },] },
];
/**
 * @nocollapse
 */
MatStepLabel.ctorParameters = () => [
    { type: TemplateRef, },
];
function MatStepLabel_tsickle_Closure_declarations() {
    /** @type {?} */
    MatStepLabel.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatStepLabel.ctorParameters;
}
//# sourceMappingURL=step-label.js.map